import React, { useState, useEffect } from "react";
import commoncss from "../css/common.module.css";
import standaloneCss from "../css/standalone.module.css";
import { ReactComponent as DownArrow } from "../assets/icons/down_grey.svg";
import { ReactComponent as UpArrow } from "../assets/icons/up_arrow.svg";
import InputGroup from "./InputGroup";

const ChipsGroup = ({
  title,
  items = [],
  selectedItems = [],
  onChange,
  singleSelect = false,
  defaultOpen = false,
  allowCustomInput = false,
  customInputLabel = "",
  customInputPlaceholder = "",
}) => {
  const [open, setOpen] = useState(defaultOpen);
  const [localItems, setLocalItems] = useState(items);
  const [customValue, setCustomValue] = useState("");

  useEffect(() => {
    setLocalItems(items || []);
  }, [items]);
  const toggleChip = (item) => {
    let updated;

    if (singleSelect) {
      updated = selectedItems.includes(item) ? [] : [item];
    } else {
      updated = selectedItems.includes(item)
        ? selectedItems.filter((i) => i !== item)
        : [...selectedItems, item];
    }

    onChange(updated);
  };

  const handleAddCustom = (e) => {
    if (e.key === "Enter" && customValue.trim()) {
      const value = customValue.trim();

      if (!localItems.includes(value)) {
        setLocalItems([...localItems, value]);
      }

      onChange(singleSelect ? [value] : [...selectedItems, value]);
      setCustomValue("");
    }
  };

  return (
    <div className={standaloneCss.accordionWrapper}>
      {/* HEADER */}
      <div
        className={standaloneCss.accordionHeader}
        onClick={() => setOpen(!open)}
      >
        <div className={standaloneCss.accordionTitle}>
          {title}
          {selectedItems.length > 0 && (
            <span className={standaloneCss.selectedCount}>
              {selectedItems.length} selected
            </span>
          )}
        </div>
        {open ? <UpArrow /> : <DownArrow />}
      </div>

      {/* BODY */}
      {open && (
        <>
          <div className={standaloneCss.chipsContainer}>
            {localItems.map((item) => (
              <div
                key={item}
                className={`${standaloneCss.chip} ${
                  selectedItems.includes(item) ? standaloneCss.chipActive : ""
                }`}
                onClick={() => toggleChip(item)}
              >
                {item}
              </div>
            ))}
          </div>

          {allowCustomInput && (
            <>
              <InputGroup
                class_={commoncss.mtMinus20}
                label={customInputLabel}
                inputs={[
                  <input
                    type="text"
                    value={customValue}
                    placeholder={customInputPlaceholder}
                    onChange={(e) => setCustomValue(e.target.value)}
                    onKeyDown={handleAddCustom}
                  />,
                ]}
              />
            </>
          )}
        </>
      )}
    </div>
  );
};

export default ChipsGroup;
